import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-personnel',
  templateUrl: './new-personnel.component.html',
  styleUrls: ['./new-personnel.component.css']
})
export class NewPersonnelComponent implements OnInit {
  title="Form-II: Form for verification of character and antecedents of All Personnel";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/personnel-details/Personnels/new-personnel/new-personnel.component.ts